import { BarLoader } from "react-spinners";


function TopRangeLoader() {
  return (
      <div style={{
        position: 'absolute',
        height: '100vh', 
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
        }} 
      >
        <BarLoader />
      </div>
      
  );
}

export default TopRangeLoader;